import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { selectUserBuilding, selectUserRole } from '../../reducers/userDataReducer'
import {
  selectBuildingsForFilter,
  formatBuildingsForFilter,
} from '../../reducers/buildingSelectorReducer'
import API from '../../api/api'
import Icon from '../Icons'

const RequestSentModal = ({ type, buildings, buttonClassName, buttonText }) => {
  const { t } = useTranslation(['upselling', 'common'])
  const resolvedButtonText = buttonText || t('upselling:requestModal.talkToAccountManagerButton')
  const [isModalVisible, setIsModalVisible] = useState()
  const [isLoading, setLoading] = useState(false)

  const handleSendEmail = async () => {
    try {
      setLoading(true)
      await API.sendUpsellingMessage({ type }, buildings[0].id)
      setIsModalVisible(true)
    } catch (error) {
      console.error(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <button
        type="submit"
        onClick={handleSendEmail}
        className={`button button-primary ctp-upselling__container__main-content__interact-button ${
          isLoading ? 'is-loading' : ''
        } ${buttonClassName}`}
        disabled={isLoading}
      >
        {resolvedButtonText}
      </button>
      {isModalVisible && (
        <div className="request-sent-modal">
          <div className="request-sent-modal__container">
            <div className="request-sent-modal__container__icon-wrapper">
              <Icon fill="#548671" icon="checkmark" viewBox="0 0 30 30" />
            </div>
            <h1>{t('upselling:requestModal.requestSentTitle')}</h1>
            <p>{t('upselling:requestModal.requestSentBody')}</p>
            <button type="submit" onClick={() => setIsModalVisible(false)} className="button">
              {t('common:actions.close')}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

RequestSentModal.propTypes = {
  buildings: PropTypes.array,
  type: PropTypes.string,
  buttonText: PropTypes.string,
  buttonClassName: PropTypes.string,
}

const getIsUserHasAccesToOnlyOneBuilding = (userRole) => {
  return userRole === 'ShiftManager'
}

export default connect((state) => {
  const userRole = selectUserRole(state)
  return {
    buildings: getIsUserHasAccesToOnlyOneBuilding(userRole)
      ? formatBuildingsForFilter([selectUserBuilding(state)])
      : selectBuildingsForFilter(state),
  }
})(RequestSentModal)
